import React from 'react';
import DownIcon from 'mdi-react/ChevronDownIcon';
import {
  DropdownItem, DropdownToggle, DropdownMenu, UncontrolledDropdown,
} from 'reactstrap';
import SettingsIcon from 'mdi-react/SettingsOutlineIcon';
import TopbarNavLink from './tobar_nav/TopbarNavLink';
import TopbarMenuItem from './TopbarMenuItem';

const TopbarSetting = () => (
  <UncontrolledDropdown className="topbar__nav-dropdown">
    <DropdownToggle className="topbar__nav-right-dropdown-toggle">
      {/*<SettingsIcon />*/}
      <i className="fa fa-cog"></i>
      {/*<DownIcon className="topbar__icon" />*/}
    </DropdownToggle>
    <DropdownMenu className="topbar__nav-dropdown-menu dropdown__menu">
      <TopbarMenuItem title="Settings" icon="user" />
      <div className="topbar__menu-divider" />
      <DropdownItem>
        <TopbarNavLink title="Facility Settings" icon="home" route="/settings/collection_settings" />
      </DropdownItem>
      <DropdownItem>
        <TopbarNavLink title="Asset Management" icon="home" route="/settings/asset_management" />
      </DropdownItem>
      <DropdownItem>
        <TopbarNavLink title="Inference Services" icon="home" route="/settings/inference_services" />
      </DropdownItem>
    </DropdownMenu>
  </UncontrolledDropdown>
);


export default TopbarSetting;
